var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.193 13.43H7.807v-2.892c0-1.924-1.804-2.049-2.928-2.091L10 2.458l4.948 5.989c-1.124.042-2.755-.094-2.755 2.09v2.893zM11.23.573A1.585 1.585 0 0 0 10 0c-.481 0-.93.209-1.23.573L2.342 8.371a1.503 1.503 0 0 0-.189 1.616c.262.526.819.867 1.42.867h1.64v3.618c0 .842.705 1.528 1.573 1.528h6.428c.868 0 1.575-.686 1.575-1.528v-3.618h1.638a1.59 1.59 0 0 0 1.42-.868 1.5 1.5 0 0 0-.191-1.616L11.23.573zM6.226 18c-.483 0-.877.449-.877 1 0 .551.394 1 .877 1h7.897c.483 0 .877-.449.877-1 0-.551-.394-1-.877-1H6.226z",
    fill: "#7ED592",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.eb4eaa5192073c77e388c14b70fa94fe.svg";
export { ForwardRef as ReactComponent };